import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import FormBuilder from "../../../components/forms/FormBuilder";
import { setGlobalLoader } from "../../../redux/actions/commonAction";
import {
  getTFtoJson,
  planTerraform,
  updateProvision,
} from "../../../redux/actions/provisionAction";

const ProvisionForm = ({ defaultState = null, onBack, show }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { newProvision } = useSelector((state) => state?.provision);
  const { tfToJson } = useSelector((state) => state?.provision);
  const [formJson, setForm] = useState([]);

  useEffect(() => {
    if (defaultState) {
      let newTfVars = [...defaultState?.tfVars];
      const regionIndex = newTfVars.findIndex((x) => x.name === "region");
      if (regionIndex !== -1) {
        newTfVars[regionIndex].default =
          newProvision?.region?.region ?? newTfVars[regionIndex].default;
      }
      setForm(newTfVars);
      dispatch(setGlobalLoader(false));
    } else if (newProvision) {
      dispatch(getTFtoJson(newProvision?.service));
    }
    //eslint-disable-next-line
  }, [newProvision, defaultState]);

  useEffect(() => {
    if (tfToJson) {
      dispatch(setGlobalLoader(false));
    }
    if (tfToJson && newProvision) {
      let updatedJson = JSON.parse(JSON.stringify(tfToJson));
      for (const data of updatedJson) {
        if (data.name === "region") {
          data["default"] = newProvision?.region?.region;
          data["disabled"] = true;
        }
        if (newProvision?.vpc?.id && data.name === "vpc_id") {
          data["default"] = newProvision?.vpc?.id;
          data["disabled"] = true;
        }
        if (data.name === "subnet_id") {
          let value =
            newProvision?.subnets?.length > 0
              ? newProvision?.subnets.map((obj) => obj.id)
              : newProvision?.subnets?.id || "";
          value = newProvision?.subnets?.length > 0 ? value.join(", ") : value;
          data["default"] = value;
          data["disabled"] = true;
        }
        if (data.name === "subnet_ids") {
          data["default"] = newProvision?.subnets.map((obj) => obj.id) || [];
          data["disabled"] = true;
        }
        if (
          newProvision?.service === "ec2_instance" &&
          data.name === "availability_zone"
        ) {
          data["default"] = newProvision?.subnets?.availabilityZone || "";
          data["disabled"] = true;
        }
      }
      setForm(updatedJson);
    }
    //eslint-disable-next-line
  }, [tfToJson, newProvision]);

  const handleSubmit = (updatedTfToJson) => {
    let tfVars = JSON.parse(JSON.stringify(formJson));
    for (const obj of tfVars) {
      obj.default = updatedTfToJson[obj.name];
    }
    const payload = {
      tfVars,
      variables: updatedTfToJson,
      credentials:
        newProvision?.accountNumber?.credName || defaultState.credentials,
      accountName:
        newProvision?.accountNumber?.credName || defaultState.accountName,
      accountNumber:
        newProvision?.accountNumber?.accountNumber ||
        defaultState.accountNumber,
      service: newProvision?.service,
      name: newProvision?.name,
      description: newProvision?.description,
    };
    if (defaultState && location.pathname === "/provision/edit") {
      dispatch(updateProvision(defaultState.id, payload));
    } else {
      dispatch(planTerraform(payload));
    }
    history.push("/provision");
  };

  return (
    (tfToJson || defaultState) && (
      <Box sx={{ display: show ? "block" : "none" }}>
        <Typography variant="h6" gutterBottom={true}>
          Service Details
        </Typography>
        <FormBuilder
          submitLabel={
            location.pathname === "/provision/edit"
              ? "Update"
              : location.pathname === "/provision/clone"
              ? "Clone"
              : "Submit"
          }
          onCancel={onBack}
          data={formJson}
          onSubmit={handleSubmit}
        />
      </Box>
    )
  );
};

export default ProvisionForm;
